import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {fragments}      from "@Common/react/fragments";
import {Load2}          from "@Common/react/load2";
import {scnv}           from "@Common/react/state-change-nested-value";
import {UseState}       from "@Common/react/use-state";

import {ShareTargetBox} from "./share-target-box";

export const BasicTarget = (
    {
        type, typeName=undefined, getAccountValue, getAccount,
        removeAccount, invokeShare,
        initSelected,
        getMessage=undefined,
        extraRender=undefined,
        next,
    }
) => cs(
    consumeContext("socialMediaStatus"),
    ["account", ({socialMediaStatus}, next) => Load2({
        _key: socialMediaStatus?.[type],
        fetch: () => socialMediaStatus?.[type] && getAccount(),
        next,
    })],
    ["unselected", (_, next) => UseState({initValue: initSelected===false, next})],
    ["onRemoveAccount", ({account}, next) => next(async () => {
        await removeAccount();
        scnv(account, ["action"], () => false);
        // account.onChange( setNestedValue( account.value, ["action"], false) );
    })],
    ["loggedIn", ({account}, next) => next(account.value?.action)],
    ({account, unselected, onRemoveAccount, loggedIn}) => next(account.value && {
        key: type,
        displayName: typeName || type,
        getUnselectedPlatforms: () => loggedIn && unselected.value ? [type] : [],
        render: ({isShared=undefined}) => fragments(
            ShareTargetBox({
                loggedIn,
                account: account.value && getAccountValue(account.value),
                unselected,
                onRemoveAccount,
                isShared,
                type,
                typeName,
                message: account.value && !unselected.value && getMessage?.(getAccountValue(account.value)),
            }),
            extraRender?.({
                account: getAccountValue(account.value),
                loggedIn,
                unselected,
                onRemoveAccount,
            }),
        ),
        sharable: loggedIn && !unselected.value,
        //
        // ...blockSharing && !unselected.value && {
        //     blockSharing: () => blockSharing(getAccountValue(account.value)),
        // },

        getSharePieces: () => [{
            id: getAccountValue(account.value).id,
            type,

            invokeShare,
        }],
    }),
);
